import React from 'react';
import { SurveyCreatorComponent, SurveyCreator, settings } from 'survey-creator-react';
import { Serializer } from 'survey-core';
import { localization } from 'survey-creator-core';
import 'survey-core/defaultV2.min.css';
import 'survey-creator-core/survey-creator-core.i18n';
import 'survey-core/survey.i18n';
import 'survey-creator-core/survey-creator-core.min.css';

export default class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.saveSurvey = this.saveSurvey.bind(this);
    this.creatorOptions = this.props.creatorOptions;
    this.survey = this.props.survey;
    this.creator = {};
    this.state = {
      mounted: false
    }
    localization.currentLocale = this.props.userLanguage;
  }

  saveSurvey (json, text) {
    this.props.saveQuestions({json: json, text: text});
  }

  componentDidMount() {
    Serializer.findProperty("itemvalue", "visibleIf").visible = false;
    Serializer.findProperty("itemvalue", "enableIf").visible = false;
    Serializer.findProperty("itemvalue", "text").visible = false;
    Serializer.removeProperty("survey", "title");
    Serializer.removeProperty("survey", "description");
    Serializer.removeProperty("survey", "logo");
    Serializer.findProperty("question", "name").visible = false;
    Serializer.findProperty("question", "title").isRequiredValue = true;
    Serializer.addProperty('question', {
      name: '_id', 
      type: 'string',  
      visible: false,
      required: false
    })

    // Set default question type 
    settings.designer.defaultAddQuestionType = "radiogroup";
    settings.propertyGrid.maximumChoicesCount = 10;
    
    // Initialize survey creator
    this.creator = new SurveyCreator(this.creatorOptions);

    this.creator.onQuestionAdded.add(function(_, options) {
      // Sets default title for question if new question
      if (options.reason === 'ADDED_FROM_PAGEBUTTON' || options.reason === 'ADDED_FROM_TOOLBOX') {
        options.question.title = "New Question";
      }

      // Sets 255 character limit on comments
      if (options.question.getType() === 'comment'){
        options.question.maxLength = 255;
      }

      // Hides Add Button and toolbox items once survey has three questions
      if (_.JSON.elements.length >= 3) {
        document.getElementsByClassName("svc-page__add-new-question svc-btn")[0].style.visibility = 'hidden';
        _.toolboxLocation = "none";
      }
    });
    
    this.creator.onModified.add(function(creator, options) {
      if (options.type === 'PROPERTY_CHANGED' && options.target.propertyHash.choices?.length > settings.propertyGrid.maximumChoicesCount) {
        creator.undo();
      }
      const questionCount = creator.JSON.elements.length
      if (options.type === 'PROPERTY_CHANGED' && questionCount > 3) {
        creator.undo();
      }
    });


    // Shows Add button once we have less than three questions
    this.creator.onElementDeleting.add(function(_, options) {
      if (_.JSON.elements.length <= 3) {
        document.getElementsByClassName("svc-page__add-new-question svc-btn")[0].style.visibility = 'visible';
        _.toolboxLocation = "left";
      }
    });

    // Gets rid of duplicate option on surveys with 3 or more questions
    this.creator.onElementAllowOperations.add(function (_, options) {
      if (_.JSON.elements?.length >= 3) {
        options.allowCopy = false;
      }
    });

    // Removes settings icon from adorners (It pops up when window has width of about 1295)
    // Referenced this (https://surveyjs.io/survey-creator/examples/create-custom-adorners/reactjs#content-code)
    this.creator.onDefineElementMenuItems.add(function (_, options) {
      for (var i = options.items.length - 1; i >= 0; i--) {
        if (options.items[i].id === "settings") {
          options.items.splice(i, 1);
        }
      }
    });

    // // Removes Upper Right tool bar options (Gets rid of save button so comment out when removing autosave)
    for (var i = this.creator.toolbarItems.length - 1; i >= 0; i--) {
      var item = this.creator.toolbarItems[i];
      this.creator.toolbarItems.splice(i, 1);
    }
    
    this.creator.saveSurveyFunc = (saveNo, callback) => {
      // Work around for single page in case we expand
      const singlePageSurvey = {
        pages: []
      }
      singlePageSurvey.pages.push({elements: this.creator.JSON.elements});
      this.saveSurvey(singlePageSurvey);
      callback(saveNo, true);
    };

    
    if (this.survey.pages?.length) {
      this.creator.JSON = this.survey.pages[0];
    }
    
    
    this.setState({
      mounted: true
    }, () => {
      // Sets min height for new surveys 
      // (SurveyJS gets height from toolBox and we only use 3 question options, so we have a short toolBox)
      document.getElementsByClassName('svc-flex-column svc-flex-row__element svc-flex-row__element--growing')[0].style.minHeight = '400px';
      // Hides Add Question button and toolbox if survey already has three questions
      if (this.creator.JSON.elements?.length >= 3) {
        document.getElementsByClassName("svc-page__add-new-question svc-btn")[0].style.visibility = 'hidden';
        this.creator.toolboxLocation = "none";
      }
    })

  }
  

  render() {
    return (
      <div>
        <h4>Questions</h4>
        {this.state.mounted ? <SurveyCreatorComponent creator={this.creator}></SurveyCreatorComponent> : <div>Loading</div>}
      </div>
    );
  }
}